import api from "../api";

const state = {
  tags: null,
  selectedTags: [],
};

const getters = {
  getTags: (state) => {
    const defaults = [
      { name: "Product tutorials" },
      { name: "UGC videos" },
      { name: "Product try-ons" },
      { name: "Informative videos" },
      { name: "Product pages" },
    ];
    const tags = Array.isArray(state.tags) ? state.tags : [];
    if (tags.length === 0) return defaults;

    const names = tags.map((t) => t.name);
    const allMatch = names.every((n) => defaults.some((d) => d.name === n));
    if (allMatch) {
      const unused = defaults.filter((d) => !names.includes(d.name));
      return [...tags, ...unused];
    }
    return tags;
  },
};

const mutations = {
  setTags(state, tags) {
    state.tags = tags;
  },
  addTag(state, tag) {
    if (!Array.isArray(state.tags)) state.tags = [];
    state.tags.push(tag);
  },
  deleteTag(state, tagId) {
    if (!Array.isArray(state.tags)) return;
    state.tags = state.tags.filter((t) => t._id !== tagId);
  },
  setSelectedTags(state, selectedTags) {
    state.selectedTags = selectedTags;
  },
  replaceTagId(state, { tempId, realTag }) {
    if (!Array.isArray(state.tags)) state.tags = [];
    state.tags = state.tags.map((t) => (t._id === tempId ? realTag : t));
  },
};

const actions = {
  async getTags({ commit }, { siteId }) {
    if (Array.isArray(state.tags)) return state.tags;
    try {
      const tags = await api.getTags({ siteId });
      commit("setTags", tags);
      return tags;
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  },

  async createTag({ commit }, tagData) {
    try {
      const newTag = await api.createTag(tagData);
      commit("addTag", newTag);
      return newTag;
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  },

  async deleteTag({ commit }, tagId) {
    try {
      await api.deleteTag(tagId);
      commit("deleteTag", tagId);
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
